/**
 * This file contains default models and params.
 */
export const DefaultAvatar = '/default/user-default-avatar.png';
export const DefaultUser = {
    model_name: 'user',
    display_name: 'Anonymer Nutzer',
    avatar_thumbnail: DefaultAvatar
};
export const DefaultClub = {
    model_name: 'club',
    display_name: 'Privater Verein',
    avatar_thumbnail: '/default/club-default-avatar.png'
};
//# sourceMappingURL=defaults.js.map